// eslint-disable-next-line max-classes-per-file
import Base, { ErrorBase } from 'requests/objects/_base'

/**
 * Vehicle equipment Object
 */
export default class VehicleEquipment extends Base {
    /**
     * @param {object} data data
     * @param {number=} data.vehicleEquipmentId vehicleEquipmentId
     * @param {string=} data.vehicleEquipmentTmsId vehicleEquipmentTmsId
     * @param {string=} data.name name
     * @param {number=} data.companyId companyId
     */
    constructor({
        vehicleEquipmentId = 0,
        vehicleEquipmentTmsId = '',
        name = '',
        companyId = 0,
        ...data
    } = {}) {
        super(data)
        this.vehicleEquipmentId = vehicleEquipmentId
        this.vehicleEquipmentTmsId = vehicleEquipmentTmsId
        this.name = name
        this.companyId = companyId
    }
}

/**
 * VehicleEquipment Object used to bind error message
 */
export class ErrorVehicleEquipment extends ErrorBase {
    constructor() {
        super()
        this.vehicleEquipmentId = ''
        this.companyId = ''
        this.name = ''
        this.vehicleEquipmentTmsId = ''
    }
}
